const loadAccountPreferencesModule = () => ({
    hasRouter: false,
    modules: [],
});
export default loadAccountPreferencesModule;
